<script>
    import { onMount } from "svelte";

    import { user } from "../../stores";

    import {
        goBack,
        replaceURL,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import {
        ErrorModal,
        PageHead,
        PageLoading,
        Tab,
    } from "../../Components/Common/index.svelte";

    import GroupDetailsTab from "./tabs/GroupDetailsTab.svelte";
    import GroupDoctorsTab from "./tabs/GroupDoctorsTab.svelte";
    import GroupManagersTab from "./tabs/GroupManagersTab.svelte";

    export let params;

    $: isUserAdmin = $user.role == 100;

    let isGettingGroupDetails = false,
        groupDetails = {},
        defaultGroupDetails = {};

    let currentTab = "";

    onMount(() => {
        if (!isUserAdmin) goBack();

        if (params.id) loadGroupDetails(params.id);

        if (!params.query) currentTab = "groupDetails";
        else _syncTab(params.query);
    });

    const loadGroupDetails = async (id) => {
        isGettingGroupDetails = true;

        await apiMethods.getMethod
            .getGroupById(id)
            .then((res) => _handleGroupDetails(res))
            .catch((err) => showException(err));

        isGettingGroupDetails = false;
    };

    const updateGroupDetails = ({ detail }) => {
        groupDetails = { ...detail };
        defaultGroupDetails = { ...detail };
    };

    const cancelEditGroupDetails = () =>
        (groupDetails = { ...defaultGroupDetails });

    const updateURL = () => {
        let url = `/Groups/view/${params.id}/`;

        if (currentTab) url += `&tab=${currentTab}`;

        replaceURL(url);
    };

    // HELPER FUNCTIONS
    const _handleGroupDetails = (res) => {
        if (!res || res.error || !res.id)
            showError(
                "Failed to load this group details, please refresh the page and try again and contact support if the issue persists.",
            );
        else {
            groupDetails = { ...res };
            defaultGroupDetails = { ...res };
        }
    };

    const _syncTab = (query) => {
        const arr = query.split("&");

        for (let i = 0; i < arr.length; i++) {
            if (arr[i].includes("tab=")) currentTab = arr[i].split("=")[1];
        }

        updateURL();
    };

    const _showGroupDetailsTab = () => {
        currentTab = "groupDetails";
        updateURL();
    };

    const _showDoctorsTab = () => {
        currentTab = "doctors";
        updateURL();
    };

    const _showManagersTab = () => {
        currentTab = "managers";
        updateURL();
    };
</script>

<PageHead title="View Group Details" />

{#if isGettingGroupDetails}
    <PageLoading />
{:else}
    <div class="flex flex-1 flex-col shadow-2xl rounded-lg bg-white">
        <div class="tabs m-4 flex-wrap">
            <Tab
                {currentTab}
                displayTab="Group Details"
                tabUrl="groupDetails"
                clickTabFunc={() => _showGroupDetailsTab()}
            />

            <Tab
                {currentTab}
                displayTab="Doctors"
                tabUrl="doctors"
                clickTabFunc={() => _showDoctorsTab()}
            />

            <!-- <Tab
                {currentTab}
                displayTab="Managers"
                tabUrl="managers"
                clickTabFunc={() => _showManagersTab()}
            /> -->
        </div>

        <div class="relative flex-1">
            <div
                class="flex flex-col overflow-y-auto absolute inset-0 gap-4 m-4"
            >
                {#if currentTab == "groupDetails"}
                    <GroupDetailsTab
                        {groupDetails}
                        on:saveEdit={updateGroupDetails}
                        on:cancelEdit={cancelEditGroupDetails}
                    />
                {:else if currentTab == "doctors"}
                    <GroupDoctorsTab groupId={groupDetails.id} />
                <!-- {:else if currentTab == "managers"}
                    <GroupManagersTab groupId={groupDetails.id} /> -->
                {/if}
            </div>
        </div>
    </div>
{/if}
